export const API_BASE = process.env.REACT_APP_API_URL || '/api';

export const API_ENDPOINTS = {
  MOT_HISTORY: (registration) => `${API_BASE}/dvsa/mot-history/${registration}`,
  VEHICLE_ENQUIRY: `${API_BASE}/dvla/vehicle-enquiry`,
  RDW_VEHICLE: (registration) => `${API_BASE}/rdw/vehicle/${registration}`,
  SMART_VEHICLE: (registration) => `${API_BASE}/v2/vehicle/${registration}`,
  CONTACT: `${API_BASE}/contact`
};
